import styled from 'styled-components'
import FormControl from './form-control'

const FormCheck = styled(FormControl)`
  display: grid;
  grid-template-columns: auto 1fr;

  label {
    margin-left: ${props => props.theme.spacing.base400};
  }
`

export default FormCheck
